module.exports = __webpack_public_path__ + "img/pic-06.6113cdb5.jpg";